import { useState } from "react";
import { Link } from "react-router-dom";
import Tilt from "./Tilt";
import QrMark from "./QrMark";
import { FREE_PRODUCT_LIMIT } from "../../plans";

// Ejemplos ilustrativos para mostrar cómo queda el catálogo según el rubro.
const demos = {
    "Gastronomía": {
        name: "La Esquina Pizzería", initials: "LE", color: "#B3261E", hue: "#F3E3D3", category: "Pizzas",
        items: [["Napolitana", "Muzzarella, tomate y ajo", 11200], ["Fugazzeta", "Rellena, con cebolla", 12500], ["Calabresa", "Longaniza y morrones", 11900]]
    },
    "Indumentaria": {
        name: "Tienda Lola", initials: "TL", color: "#5B2A86", hue: "#EDE3F4", category: "Remeras",
        items: [["Remera oversize", "Algodón peinado", 18900], ["Musculosa básica", "Varios colores", 12500], ["Remera estampada", "Talles S al XL", 21000]]
    },
    "Peluquería": {
        name: "Barbería Norte", initials: "BN", color: "#1F4E8C", hue: "#DDE6F1", category: "Servicios",
        items: [["Corte clásico", "30 minutos", 9000], ["Corte y barba", "45 minutos", 13000], ["Color", "Consultá por turno", 22000]]
    },
    "Profesionales": {
        name: "Podología Sur", initials: "PS", color: "#1B6E3A", hue: "#DCEFE2", category: "Atención",
        items: [["Consulta", "Primera visita", 15000], ["Tratamiento de uñas", "Por sesión", 20000], ["Plantillas", "A medida", 38000]]
    }
};

const money = (n) => "$ " + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

const Hero = () => {

    const [rubro, setRubro] = useState("Gastronomía");
    const demo = demos[rubro];

  return (
    <section className="lp-hero" data-scroll>
        <div className="lp-hero-bg" aria-hidden="true">
            <span className="lp-blob lp-blob-1"></span>
            <span className="lp-blob lp-blob-2"></span>
            <span className="lp-float lp-float-1"><QrMark size={26}></QrMark></span>
            <span className="lp-float lp-float-2"><QrMark size={20}></QrMark></span>
            <span className="lp-float lp-float-3"><QrMark size={16}></QrMark></span>
        </div>

        <div className="lp-hero-text lp-hero-intro">
            <span className="lp-eyebrow">Menús y catálogos con QR</span>
            <h1>Tu menú o catálogo online, <span className="lp-highlight">con tu propio QR</span>.</h1>
            <p className="lp-lead">Cargá tus productos con foto y precio, cambialos cuando quieras y tus clientes los ven al instante escaneando el QR o entrando a tu link.</p>

            <div className="lp-hero-actions">
                <Link to="/register" className="lp-btn lp-btn-primary">Crear mi catálogo gratis</Link>
                <a href="/pizzeria-don-tito" target="_blank" rel="noreferrer" className="lp-btn lp-btn-secondary">
                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5"></rect><path d="M11 18h2"></path></svg>
                    Ver un catálogo de ejemplo
                </a>
            </div>
            <p className="lp-hero-note">Gratis hasta {FREE_PRODUCT_LIMIT} productos · Sin tarjeta</p>
        </div>

        <div className="lp-hero-demo lp-hero-intro" aria-label="Así se ve según tu rubro">
            <div className="lp-tabs" role="tablist">
                {
                    Object.keys(demos).map(name => (
                        <button key={name} type="button" role="tab" aria-selected={rubro === name} className={"lp-tab" + (rubro === name ? " lp-tab-on" : "")} onClick={() => setRubro(name)}>
                            {name}
                        </button>
                    ))
                }
            </div>

            <div className="lp-phone-stage">
            <Tilt className="lp-phone-tilt" max={10}>
            <div className="lp-phone" aria-hidden="true">
                <div className="lp-phone-screen">
                    <div className="lp-phone-cover" style={{ background: demo.color }}></div>
                    <div className="lp-phone-body">
                        <div className="lp-phone-logo" style={{ background: demo.color }}>{demo.initials}</div>
                        <strong className="lp-phone-name">{demo.name}</strong>
                        <span className="lp-phone-category" style={{ color: demo.color }}>{demo.category}</span>
                        {
                            demo.items.map(([name, desc, price], i) => (
                                <div key={rubro + name} className="lp-phone-item" style={{ animationDelay: (i * 70) + "ms" }}>
                                    <div className="lp-phone-photo" style={{ background: demo.hue }}></div>
                                    <div className="lp-phone-item-text">
                                        <span className="lp-phone-item-name">{name}</span>
                                        <span className="lp-phone-item-desc">{desc}</span>
                                    </div>
                                    <span className="lp-phone-item-price">{money(price)}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <span className="lp-phone-glare"></span>
            </div>
            </Tilt>
            <div className="lp-phone-qr" aria-hidden="true"><QrMark size={34}></QrMark><span>Escaneá</span></div>
            </div>
        </div>
    </section>
  )
}

export default Hero
